document.querySelector('[data-menu]')?.addEventListener('click',()=>document.getElementById('nav').classList.toggle('open'));
const f=document.querySelector('[data-product-form]');
if(f){const vs=JSON.parse(f.querySelector('[data-variants]').textContent),id=f.querySelector('[data-id]'),b=f.querySelector('[data-buy]'),p=document.querySelector('[data-price]');
const fmt=c=>(c/100).toLocaleString('fr-FR',{style:'currency',currency:Shopify.currency.active});
const upd=()=>{const sel=[...f.querySelectorAll('.opt')].map(o=>o.querySelector('input:checked')?.value);
const v=vs.find(v=>v.options.every((x,i)=>!sel.length||x===sel[i]));
if(!v){b.disabled=true;b.textContent='Indisponible';return}
id.value=v.id;b.disabled=!v.available;b.textContent=v.available?'Ajouter au panier':'Épuisé';
p.innerHTML=fmt(v.price)+(v.compare_at_price>v.price?' <s>'+fmt(v.compare_at_price)+'</s>':'');
history.replaceState(null,'','?variant='+v.id)};
f.addEventListener('change',upd);}


/* Guide des tailles */
(function(){
  var d=document.querySelector('[data-size-dialog]');
  if(!d)return;
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-size-open]')){
      e.preventDefault();
      if(d.showModal){d.showModal()}else{d.setAttribute('open','')}
      return;
    }
    if(e.target.closest('[data-size-close]')||e.target===d){
      if(d.close){d.close()}else{d.removeAttribute('open')}
      return;
    }
    var t=e.target.closest('[data-size-tab]');
    if(t){
      var k=t.dataset.sizeTab;
      d.querySelectorAll('[data-size-tab]').forEach(function(b){b.setAttribute('aria-selected',String(b===t))});
      d.querySelectorAll('[data-size-panel]').forEach(function(p){p.hidden=p.dataset.sizePanel!==k});
    }
  });
})();
